<div class="row mt-2">
  <div class="col-md-12 order-table">
    <h6>Send SMS Message Instructions</h6>
    <div>
      <p>Fill out the form and hit the send button to send an SMS message (text message) to all subscribers.</p>
    </div>
  </div>
</div>
